// 助威解锁弹窗
import React from 'react'
import ReactModal from 'react-modal'
import { isRtl } from 'src/helper/tool'

import './index.less'

export default class extends React.Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props)
  }

  state = {
    scrollTop: 0 // 滚动调位置
  }

  componentDidUpdate() {}

  componentDidMount() {}

  componentWillUnmount() { }

  onToggleModal = async () => {
    this.props.onToggleModal()
  }

  replaceLang = (txt, val) => {
    const newTxt = txt.replace(/\{0\}/g, val)
    return (newTxt)
  }

  render() {
    const {
      visible,
      language,
      lang,
      userInfo,
      giftUrl
    } = this.props
    return (
      <div className="modal-wrap">
        <div
          onClick={this.onToggleModal}
        >
          <ReactModal
            style={{
              overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.75)',
                zIndex: 1000
              }
            }}
            className={`custom-wrapper--modal`}
            isOpen={visible}
            ariaHideApp={false}
          >
            <div className="certificate-wrap" onClick={e => e.stopPropagation()}>
              <div className="hd">
                <span className="title">{lang.certificate}</span>
              </div>
              <div className={`bd ${isRtl(language) ? 'arlang' : ''}`}>
                <h2 className="title">
                  {this.replaceLang(lang.certificate_description1, userInfo.nickname)}
                </h2>
                <div className="text-wrap">
                  <p>{lang.certificate_description2}</p>
                  <p>{this.replaceLang(lang.certificate_description3, userInfo.countryName)}</p>
                </div>
              </div>
              <div className="ft">
                <div className="img-wrap">
                  <img src={giftUrl} />
                </div>
              </div>
            </div>
          </ReactModal>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/national-star/certificate-modal/index.js